import { selectGanttInstanceData } from '../Gantt/store';
import { GanttQueue, NodeType, QueueBatchNode, QueueNode, QueueTaskNode } from '../Gantt/types';
import { createSelector } from 'reselect';

type ReducedNodes = {
  queue: GanttQueue;
  node: QueueTaskNode | QueueBatchNode;
  searchArray: string;
};

export const searchNodes = (instanceId: string, search: string) =>
  createSelector([selectGanttInstanceData(instanceId), () => search], (ganttData) =>
    ganttData.queues
      .reduce(
        (acc, queue) => [
          ...acc,
          ...queue.queueNodes.filter(filterBreakNodes).map((node) => {
            return {
              queue,
              node,
              searchArray:
                node.type === NodeType.TASK
                  ? [
                      node.productName,
                      node.name,
                      node.orders?.map((order) => order.orderId).join(', '),
                      node.productionOrderDetails?.number,
                      node.productionOrderDetails?.externalId,
                    ].join(' ')
                  : [
                      node.name,
                      ...(node.tasks || []).map((task) =>
                        [
                          task.productName,
                          task.name,
                          task.orders?.map((order) => order.orderId).join(', '),
                          task.productionOrderDetails?.number,
                          task.productionOrderDetails?.externalId,
                        ].join(' '),
                      ),
                    ].join(' '),
            };
          }),
        ],
        [] as ReducedNodes[],
      )
      .filter(({ searchArray }) => searchArray.toLowerCase().includes(search.toLowerCase())),
  );

const filterBreakNodes = (node: QueueNode): node is QueueTaskNode | QueueBatchNode => node.type !== NodeType.BREAK;
